import React, { useRef } from 'react';
import { useProfile } from '../Try/ProfileContext';
import profile from '../Assets/person.png';

const ProfilePictureUpload = ({ size = 40, readOnly = false }) => {
  const { profileImage, refreshProfileImage } = useProfile();
  const fileInputRef = useRef(null);
  const userId = localStorage.getItem('userID');

  const handleImageChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      handleSubmit(selectedFile);
    }
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleSubmit = async (file) => {
    if (!file) {
      alert('Please select an image to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('profile', file);

    try {
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/member/PostProfileImageUpload?ID=${userId}`,
        {
          method: 'POST',
          body: formData,
        }
      );

      if (response.ok) {
        alert('Profile image uploaded successfully!');
        // Refresh profile image across all components
        refreshProfileImage();
      } else {
        alert('Failed to upload the profile image.');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('An error occurred while uploading the profile image.');
    }
  };

  return (
    <div style={{ textAlign: 'center', alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
      {!readOnly && (
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          ref={fileInputRef}
          style={{ display: 'none' }}
        />
      )}
      <img
        src={profileImage || profile}
        alt="Profile"
        onClick={!readOnly ? handleImageClick : undefined}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: '50%',
          cursor: readOnly ? 'default' : 'pointer',
          border: '2px solid #ccc',
        }}
        title={readOnly ? "Profile picture" : "Click to upload a new picture"}
      />
    </div>
  );
};

export default ProfilePictureUpload;